import Filters, { FilterProps } from '$store/components/search/Filters.tsx'
import Sort from '$store/components/search/Sort.tsx'
import Icon from '$store/components/ui/Icon.tsx'
import Modal from '$store/components/ui/Modal.tsx'
import type { ProductListingPage } from 'apps/commerce/types.ts'
import { useId } from 'site/sdk/useId.ts'

type Props = Pick<ProductListingPage, 'filters' | 'sortOptions'> & {
    pageInfo: ProductListingPage['pageInfo']
    url: string
    isDepartment: boolean
    selectedSort?: string
    filterNotDepartament?: boolean
    isCollection?: boolean
    categories: string[]
} & FilterProps

function SearchControls({
    sortOptions,
    url,
    isDepartment,
    selectedSort,
    formattedFilters,
    currentPath,
}: Props) {
    const filtersModalCloseId = 'close-modal-controls-filters'

    return (
        <div class='flex justify-between gap-8 w-full lg:w-fit px-2 lg:px-0'>
            <div class='flex flex-row items-center justify-between w-full gap-x-2'>
                <label
                    for={filtersModalCloseId}
                    class='border flex xl:hidden h-12 flex-1 px-4 text-neutral-0 text-sm font-lato items-center justify-between border-neutral-4'
                >
                    Filtrar
                    <Icon id='FilterList' width={16} height={16} />
                </label>
                {sortOptions.length > 0 && (
                    <Sort selectedSort={selectedSort} sortOptions={sortOptions} url={url} />
                )}
            </div>

            <Modal id={filtersModalCloseId}>
                <div class=' max-w-full lg:max-w-[25vw] w-full h-full bg-white absolute top-0 -right-[100vw] peer-checked:group-[]:right-0 duration-300 overflow-y-auto'>
                    <Filters
                        isDepartment={isDepartment}
                        formattedFilters={formattedFilters}
                        currentPath={currentPath}
                        filtersModalCloseId={filtersModalCloseId}
                    />
                </div>
            </Modal>
        </div>
    )
}

export default SearchControls
